import * as Types from '../constants/Types';

export const uploadAction = (filters) => ({type: Types.UPLOAD_FILE_ACTION, filters});
export const uploadSuccess = (file, fieldName) => ({type: Types.UPLOAD_FILE_SUCCESS, file, fieldName});
export const uploadReset = () => ({type: Types.UPLOAD_FILE_RESET});